import { Suspense } from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import ManageContent from '~/components/admin/manage-content/ManageContent';
import { AdminRoles } from '~/lib/constants/permissions.constants';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';
import PageNotFoundPage from '~/pages/404';
import ModifyNoteTemplateRevisions from '~/pages/admin/ModifyNoteTemplateRevisions';
import ModifyNoteTemplates from '~/pages/admin/ModifyNoteTemplates';
import UserProfile from '~/pages/admin/ProviderProfile';
import TechOpsPage from '~/pages/admin/TechOps';
import UsersPage from '~/pages/admin/users';
import Loading from '~/pages/loading';
import { Path } from '~/routes/constants';

//  TODO enable when we have a cache-busting strategy?
// const LazySurveySchemaPage = lazy(() => import('~/pages/admin/survey-schema'));
// const LazyUsersPage = lazy(() => import('~/pages/admin/users'));
// const LazyPageNotFoundPage = lazy(() => import('~/pages/404'));

export const AdminRoutes = () => {
  const { roles } = useGlobalContext();
  const { techOpsAdminPortal: isTechOpsAdminPortalEnabled } =
    useFlags<LDFlags>();
  const isContentManager =
    roles && roles.includes(AdminRoles.ADMIN_MANAGE_CONTENT);

  const SuspenseWrapper = (Component: React.ComponentType) => (
    <Suspense fallback={<Loading />}>
      <Component />
    </Suspense>
  );

  const ContentManagerPage = (Component: React.ComponentType) => {
    return isContentManager
      ? SuspenseWrapper(Component)
      : SuspenseWrapper(PageNotFoundPage);
  };
  return (
    <Switch>
      <Route
        exact
        path={[Path.HOME, Path.LOGIN, Path.PORTAL, Path.ADMIN]}
        render={() => <Redirect to="/admin/users" />}
      />
      <Route
        exact
        path="/admin/users"
        render={() => SuspenseWrapper(UsersPage)}
      />
      {isTechOpsAdminPortalEnabled && (
        <Route
          exact
          path={Path.ADMIN_TECH_OPS}
          render={() => SuspenseWrapper(TechOpsPage)}
        />
      )}
      <Route
        exact
        path={`${Path.ADMIN_VIEW_PROFILE}/:id/:subPath(info|calendar)`}
        render={() => SuspenseWrapper(UserProfile)}
      />
      <Route
        exact
        path={[Path.ADMIN_MANAGE_CONTENT]}
        render={() => ContentManagerPage(ManageContent)}
      />
      <Route
        exact
        path={[Path.ADMIN_MANAGE_CONTENT_NOTE_TEMPLATE]}
        render={() => ContentManagerPage(ModifyNoteTemplates)}
      />
      <Route
        exact
        path={[Path.ADMIN_MANAGE_CONTENT_NOTE_TEMPLATE_REVISION]}
        render={() => ContentManagerPage(ModifyNoteTemplateRevisions)}
      />
      <Route render={() => SuspenseWrapper(PageNotFoundPage)} />
    </Switch>
  );
};
